module.exports = __webpack_public_path__ + "static/media/NovotelSipcot03.7fc516fe.jpg";